// extracted by mini-css-extract-plugin
export default {"panel-btn":"EditorCanvas_panel-btn__hSLqS","full-page-loader":"EditorCanvas_full-page-loader__b8G6J","download-ct":"EditorCanvas_download-ct__kwOH-"};